export default __webpack_public_path__ + "static/media/at.78dc4d74.svg";